import EntryActionTypes from '../../constants/EntryActionTypes';

// eslint-disable-next-line import/prefer-default-export
export const fetchActionsInCurrentSellitem = () => ({
  type: EntryActionTypes.ACTIONS_IN_CURRENT_SELLITEM_FETCH,
  payload: {},
});
